import { Button, Modal } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import { useDispatch } from "react-redux";
import {
  GetAllClaimsList,
  SubmitClaimIndividualMulti,
} from "../config/cliamApi";

const SubmitMultipleClaimModal = ({
  show,
  setShowSuccessModal,
  onClose,
  claims,
  description,
  body,
  setPage,
  setRowsPerPage,
  setErrorDescription,
  setShowFailedModal,
}) => {
  const dispatch = useDispatch();
  const handleSubmit = async () => {
    const requestBody = {
      claim_data: claims?.map((claim) => ({
        claimid: claim.claimfull_id,
        claim_type: claim.claim_type,
      })),
    };
    try {
      const response = await dispatch(
        SubmitClaimIndividualMulti(requestBody)
      ).unwrap();
      if (response?.success) {
        setShowSuccessModal(true);
        onClose();
        setPage(0);
        setRowsPerPage(10);
        await dispatch(GetAllClaimsList(body)).unwrap();
      } else {
        setErrorDescription(response?.message);
        setShowFailedModal(true);
        onClose();
      }
    } catch (error) {
      setErrorDescription(error?.message);
      setShowFailedModal(true);
      onClose();
    }
  };
  return (
    <Modal show={show} centered dialogClassName="wizard-modal" size="lg">
      <Modal.Body>
        <FalconCloseButton
          onClick={onClose}
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
        />
        <Flex direction="column" alignItems="center" className="mb-3">
          <h6 className="fs-8 text-capitalize text-700">Submit Claims</h6>
          <h6 className="text-center text-700">{description}</h6>
          <h6 className="fs-10 text-600 text-center">
            Are you sure you want to Submit
            <span className="text-danger"> {claims?.length}</span> claims?
          </h6>
        </Flex>

        <hr />
        <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
          <Button variant="danger" size="sm" onClick={onClose}>
            No
          </Button>
          <Button variant="success" size="sm" onClick={handleSubmit}>
            Yes
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SubmitMultipleClaimModal;
